<template>
    <div class="loan_wrap">
        <div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
			<div class="big_tit">{{ $t('贷款申请') }}</div>
		</div>
        <!-- 顶部图 -->
        <div class="top">
            <div class="text">
                <span>{{ $t('创业贷款') }}</span>
                <span>{{ $t('资金周转服务') }}</span>
            </div>
            <div class="btns">
                <span @click="handleApply">{{ $t("在线申请") }}</span>
                <span @click="handleMine">{{ $t("我的贷款") }}</span>
            </div>
        </div>
        <!-- 贷款无忧 -->
        <div class="worry_free">
            <div class="main_title title">{{ $t('贷款无忧') }}</div>
            <ul>
                <li v-for="(item, index) of worryFreeData" :key="index" class="en_li">
                    <img :src="item.icon"/>
                    <div class="name">{{ item.name }}</div>
                    <div class="desc">{{ item.desc }}</div>
                </li>
            </ul>
        </div>
        <!-- 关于我们 -->
        <div class="about">
            <div class="main_title title">{{ $t('关于我们') }}</div>
            <div class="content">
                <p>
                    {{ $t('贷款金融服务') }}
                </p>
                <p>
                    {{ $t('利息低还款方式灵活') }}
                </p>
                <p>{{ $t('当天放款') }}</p>
                <p>
                    {{ $t('不想向同学朋友开口借钱') }}
                </p>
            </div>
            <div class="ad">
                <p><span>{{ $t('致力于创业者贷款服务') }}</span></p>
                <p><span>{{ $t('解决您的资金困扰') }}</span></p>
            </div>
        </div>
        <!-- 合作伙伴 - 在线借贷平台 -->
        <div class="partner">
            <div class="main_title">{{ $t('合作伙伴') }}</div>
            <ul>
                <li v-for="(item, index) of partnerIcon" :key="index" @click="handleJump(item.path)">
                    <img :src="item.icon" alt="">
                </li>
            </ul>
        </div>
        <!-- 底部 -->
        <footers></footers>
    </div>
</template>

<script>
import footers from '@/components/bsFooter.vue'
import { Toast, Icon } from 'vant'
export default {
    components:{
        footers
    }, 
    data() {
        return { 
            textList:[
                {
                    title: this.$t('客户服务'),
                    subset: [
                        {
                            path:'',
                            text: this.$t('在线客服')
                        },
                    ]
                },
                {
                    title: this.$t('隐私和政策'),
                    subset: [
                        {
                            path: '/promote/#/privacyPolicy',
                            text: this.$t('隐私政策')
                        },
                    ]
                },
                {
                    title: this.$t('用户中心'),
                    subset: [
                        {
                            path: '/register',
                            text: this.$t('用户注册')
                        },
                        {
                            path: '/me',
                            text: this.$t('我的钱包')
                        }
                    ]
                },
                {
                    title: this.$t('关于我们'),
                    subset: [
                        {
                            path: 'https://java-shop.piwfynwbgv.bond/#/credit',
                            text: this.$t('关于我们')
                        },
                    ]
                },
            ],
            email:'',
            logo:localStorage.getItem('logo') || '',
            worryFreeData: [
                {
                    name: this.$t('灵活额度'),
                    desc: this.$t('贷款期限一年'),
                    icon: require('@/assets/images/worry_free1.png'),
                    iconName: 'meiyuan9'
                },
                {
                    name: this.$t('急速放款'),
                    desc: this.$t('最快一小时通过审核'),
                    icon: require('@/assets/images/worry_free2.png'),
                    iconName: 'huojianjiasu'
                },
                {
                    name: this.$t('安全无忧'),
                    desc: this.$t('安全无忧2'),
                    icon: require('@/assets/images/worry_free3.png'),
                    iconName: 'dunpai'
                }
            ],
            isCheckAvailability: 'false',
            partnerIcon: [],
            paymentList: [
                {
                    path: 'https://www.binance.com/',
                    icon: require('@/assets/images/footer/1.png'),
                    name: 'Binance'
                },
                {
                    path: 'https://www.huobi.com/',
                    icon: require('@/assets/images/footer/2.png'),
                    name: 'Huobi'
                },
                {
                    path: '',
                    icon: require('@/assets/images/footer/3.png'),
                    name: 'OKX'
                },
                {
                    path: '',
                    icon: require('@/assets/images/footer/4.png'),
                    name: 'Kraken'
                },
                {
                    path: 'https://www.dbs.com.sg/',
                    icon: require('@/assets/images/footer/5.png'),
                    name: 'coinbase'
                },
                {
                    path: 'https://www.hsbc.com.hk/',
                    icon: require('@/assets/images/footer/6.png'),
                    name: 'MetaMask'
                },
                {
                    path: 'https://portal.vietcombank.com.vn/',
                    icon: require('@/assets/images/footer/7.png'),
                    name: 'KuCoin'
                },
                {
                    path: 'https://www.nab.com.au/',
                    icon: require('@/assets/images/footer/8.png'),
                    name: 'Bitfinex'
                },
            ]
        }
    },
    async created() {
        this.$parent.footer('item', false);
            // const paths = [
            //     'https://www.jpmorganchase.com/',
            //     'https://www.bankofamerica.com/',
            //     'https://www.wellsfargo.com/',
            //     'https://www.citi.com/',
            //     'https://www.goldmansachs.com/',
            //     'https://www.hsbc.com',
            //     'https://www.ubs.com',
            //     'https://www.credit-suisse.com',
            //     'https://www.barclays.co.uk/',
            //     'https://www.sc.com/en/',
            //     'https://10bestpersonalloans.com/go/pmax-usa-eng-d-g.html#o6',
            //     'https://www.mastercard.com/global/en.html',
            //     'https://www.moneyhero.com.hk/en',
            // ]
            // for (let i = 0; i < paths.length; i++) {
            //     this.partnerIcon.push({
            //         icon: require(`@/assets/images/partner/s${i + 1}.png`),
            //         path: paths[i]
            //     })
            // }
            const paths = [
                'https://www.cimbclicks.com.my',
                'https://www.cimb.com.my',
                'https://www.rhbgroup.com',
                'https://www.loanstreet.sg/',
                'https://www.dbs.com.sg/',
                'https://www.graceloanadvance.com',
                'https://hk.lendela.com',
                'https://epaycash.hk',
                'https://www.hangseng.com/',
                'https://www.hsbc.com.hk',
            ]
            for (let i = 0; i < 10; i++) {
                this.partnerIcon.push({
                    icon: require(`@/assets/images/partner/${i + 1}.jpg`),
                    path: paths[i]
                })
            }
    },
    methods: {
        subscription() {

        },
        handleJump(path) {
            if (window.plus) {
                plus.runtime.openURL(encodeURI(path + '?wt=app'))
                return
            } else {
                window.open(path)
            }
        },
        handleApply() {
            this.$router.push('/loanApply')
        },
        handleMine() {
            this.$router.push('/loanMy')
        }
    }
}
</script>

<style lang="scss" scoped>
.red_top_bg {
	position: fixed;
	top: 0;
	z-index: 10;
}
.loan_wrap {
    width: 100%;
    height: 100%;
    font-size: 14px;
    padding-top: 44px;

    .top {
        height: 251px;
        position: relative;
        background: url('~@/assets/images/topbg.png') no-repeat center center / 100% 100%;
        .text {
            position: absolute;
            top: 74px;
            left: 0;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;

            span {
                &:nth-child(1) {
                    font-weight: 600;
                    font-size: 24px;
                    color: #F89900;
                }

                &:nth-child(2) {
                    font-size: 16px;
                    font-weight: 500;
                    color: #fff;
                    margin-top: 10px;
                }
            }

            &.en_text {
                top: 40px;

                span {
                    text-align: center;
                    transform: scale(.9);
                }
            }
        }

        .btns {
            width: 100%;
            position: absolute;
            bottom: 43px;
            left: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 32px;
            box-sizing: border-box;

            span {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 139px;
                height: 37px;
                border: 1px solid #F89900;
                color: #F89900;
                font-size: 16px;
                font-weight: 500;
                border-radius: 4px;
                white-space: nowrap;
                padding: 0 10px;
                &:nth-child(1) {
                    background: #F89900;
                    color: #fff;

                }

                &:nth-child(2) {
                    margin-left: 37px;
                }

                &.disabled {
                    opacity: .5;
                }
            }
        }
    }
    .worry_free {
        margin-top: 24px;

        .title {
            color: #333;
        }

        ul {
            margin-top: 44px;
            padding: 0 49px 0 50px;

            li {
                width: 100%;
                min-height: 237px;
                border: 1px solid #ededed;
                margin-bottom: 17px;
                border-radius: 8px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                &:last-child {
                    .icon {
                        font-size: 65px;
                    }
                }

                &.en_li {

                    .desc,
                    .name {
                        transform: translateY(-10px);
                    }
                }

                .icon {
                    font-size: 75px;
                }

                .name {
                    margin-top: 34px;
                    color: #333;
                    font-size: 16px;
                    font-weight: 600;
                }

                .desc {
                    margin-top: 20px;
                    line-height: 20px;
                    font-size: 14px;
                    color: #777;
                    text-align: center;
                }

                &:nth-child(1) {
                    img {
                        width: 74.45px;
                        height: 74.45px;
                    }

                    .desc {
                        padding: 0 17px;
                    }
                }

                &:nth-child(2) {
                    img {
                        width: 93px;
                        height: 92px;
                    }

                    .desc {
                        padding: 0 40px;
                    }
                }

                &:nth-child(3) {
                    img {
                        width: 56px;
                        height: 63px;
                    }

                    .desc {
                        padding: 0 10px;
                    }
                }
            }
        }
    }

    .about {
        width: 100%;
        padding-bottom: 60px;
        background: #212121;
        padding-top: 36px;

        .title {
            color: #fff;
        }

        .content {
            margin-top: 25px;
            padding: 0 14px;

            p {
                font-weight: 500;
                font-size: 12px;
                line-height: 18px;
                color: #fff;
                // text-align: justify;

                &:last-child {
                    text-align: center;
                    margin-top: 10px;
                    margin-bottom: 30px;
                }
            }
        }

        .ad {
            position: relative;
            width: 100vw;
            height: 64px;
            transform: translateX(-10px);

            p {
                display: inline-flex;
                justify-content: center;
                align-items: center;
                width: 216px;
                height: 32px;
                background: url(~@/assets/images/c1.png) no-repeat center / 100% 100%;
                position: absolute;
                left: 30px;
                top: 0;
                color: #212121;
                white-space: nowrap;

                &:nth-child(2) {
                    background: url(~@/assets/images/c2.png) no-repeat center / 100% 100%;
                    top: auto;
                    left: auto;
                    right: 0;
                    bottom: 0;
                    color: #F89900;
                }
            }

            &.en_ad {
                span {
                    transform: scale(.77);
                }
            }
        }
    }

    .partner {
        margin-top: 34px;
        padding-bottom: 48px;

        ul {
            margin-top: 40px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            padding: 0 17px;

            li {
                width: 161px;
                height: 44px;
                margin-bottom: 24px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }

    .main_title {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        font-weight: 600;
        position: relative;
        color: #333;

        &::after {
            content: '';
            display: block;
            width: 57px;
            height: 2px;
            background: #F89900;
            position: absolute;
            bottom: -7px;
            left: 50%;
            transform: translateX(-50%);
        }
    }
}
.footers {
    padding-bottom: 0px;
}
</style>